import { createSelector } from 'reselect';

export const fundingSourceSelector = (state) => state.fundingsources;

export const selectFundingSource = createSelector(
  fundingSourceSelector,
  (state) => state.fundingsources,
);

export const selectFundingSourceDetails = createSelector(
  fundingSourceSelector,
  (state) => state.accountDetails,
);

export const selectFundingPurposeSource = createSelector(
  fundingSourceSelector,
  (state) => state.accountPurposes,
);
